module.exports = __webpack_public_path__ + "static/img/95.c45d9787.png";